import { CONFIG } from './config'

export const WORDS = [
  'timadju',
  'aravac',
  'nimadju',
  'caucau',
  'mareka',
  'kemasi',
  'nakuya',
  'makaya',
  'payuan',
  'macaqu',
  'nanguaq',
  'sanguaq',
  'ayatua',
  'tjuruvu',
  'uqaljai',
  'ljemita',
  'pinaka',
  'namaya',
  'kamaya',
  'saqetju',
  'vurasi',
  'utubai',
  'kiukai',
  'pairang',
  'patjara',
  'mangtjez',
  'tjenglai',
  'kitulu',
  'semupu',
  'nemanga',
  'kuljelje',
  'vaquan',
  'palisi',
  'madjele',
  'kirimu',
  'kinacu',
  'katiaw',
  'tigami',
  'kisacu',
  'madrusa',
  'nekanga',
  'nikama',
  'sinzia',
  'taiwan',
  'nutiav',
  'kuisang',
  'qatjuvi',
  'saviki',
  'padjele',
  'madjulu',
  'malivu',
  'kivala',
  'pacunu',
  'izainu',
  'padain',
  'malada',
  'qepuan',
  'makuda',
  'nungida',
  'samaza',
  'tjianes',
  'kemuda',
  'tiaken',
  'pariuk',
  'sunciu',
  'palamu',
  'kemesa',
  'hakasi',
  'izuanga',
  'kemljang',
  'paveli',
  'tjenglay',
  'linalja',
  'nikina',
  'qapulu',
  'ljegean',
  'kisudju',
  'inianga',
  'mananga',
  'caquan',
  'tiamdju',
  'duduan',
  'kacuin',
  'masiaq',
  'mapida',
  'taidai',
  'maculju',
  'bukusi',
  'kasinu',
  'tjainan',
  'pidanga',
  'vencik',
  'cemavu',
  'cinavu',
  'tikama',
  'katiav',
  'venali',
  'kaukav',
  'siubai',
  'kumuing',
  'kimadju',
  'pasusu',
  'matjani',
  'paukuz',
  'saljinga',
  'tiribi',
  'pualjak',
  'namasi',
  'kemacu',
  'vineli',
  'bukesi',
  'timanga',
  'nutiaw',
  'tjekeza',
  'qecilu',
  'maculja',
  'ljasiak',
  'hikuki',
  'tikina',
  'niaken',
  'ljamljam',
  'sasequ',
  'lunbun',
  'maljama',
  'siqunu',
  'masusu',
  'senema',
  'zukuan',
  'navaik',
  'muqami',
  'temulu',
  'turaku',
  'tuaicu',
  'remasi',
  'vuciar',
  'masalu',
  'cengceng',
  'inayan',
  'kaiven',
  'inalap',
  'kivaqu',
  'tiamen',
  'zemian',
  'kiqaung',
  'veljvelj',
  'maleva',
  'maipuq',
  'manganga',
  'sakinu',
  'calinga',
  'paiwan',
  'masudju',
  'sinika',
  'vakela',
  'valanga',
  'daihiu',
  'dangdang',
  'zemaing',
  'muakai',
  'marivu',
  'gemalju',
  'tuazua',
]

if (CONFIG.normalization) {
  WORDS.forEach((val, i) => (WORDS[i] = val.normalize(CONFIG.normalization)))
}

function shuffle(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
}

if (CONFIG.shuffle) {
  shuffle(WORDS)
}
